export default __webpack_public_path__ + "static/media/marauders-map-v3-01-01.012a0ea5.jpg";